function isRetainerDue(deal) {
  if (!deal.is_retainer || !deal.retainer_next_confirmation_at) return false;
  return new Date(deal.retainer_next_confirmation_at).getTime() <= Date.now();
}

function DealsKanban({ columns, onOpenDeal, onDropStage, onConfirmRetainer }) {
  const handleDragStart = (event, dealId) => {
    event.dataTransfer.setData('text/plain', dealId);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className="kanban crm__kanban">
      {columns.map((column) => (
        <div
          key={column.key}
          className="kanban__column"
          style={{
            backgroundColor: column.backgroundColor || undefined,
            borderColor: column.backgroundColor || undefined
          }}
          onDragOver={(event) => {
            event.preventDefault();
            event.dataTransfer.dropEffect = 'move';
          }}
          onDrop={(event) => {
            event.preventDefault();
            const dealId = event.dataTransfer.getData('text/plain');
            if (dealId) {
              onDropStage(dealId, column.key);
            }
          }}
        >
          <div className="kanban__head" style={{ color: column.textColor || undefined }}>
            <h5>{column.title}</h5>
            <span>{column.tasks.length}</span>
          </div>
          <div className="kanban__cards">
            {column.tasks.map((deal) => (
              <div
                key={deal.id}
                className="kanban__card"
                draggable
                onDragStart={(event) => handleDragStart(event, deal.id)}
                onClick={() => onOpenDeal(deal)}
              >
                <div className="kanban__title" title={deal.title}>{deal.title}</div>
                <div className="kanban__meta">{deal.crm_company_name || 'Без компании'}</div>
                <div className="kanban__chips">
                  {deal.amount ? <span className="chip">{deal.amount} {deal.currency}</span> : <span className="muted">Без суммы</span>}
                  {deal.is_retainer && <span className="chip">Абонентское</span>}
                </div>
                {deal.contact_names?.length > 0 && (
                  <div className="kanban__meta">{deal.contact_names.join(', ')}</div>
                )}
                {isRetainerDue(deal) && (
                  <button
                    type="button"
                    className="ghost crm__confirm"
                    onClick={(event) => {
                      event.stopPropagation();
                      onConfirmRetainer?.(deal);
                    }}
                  >
                    Подтвердить период
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default DealsKanban;
